<template>
  <BaseLocationInput
    :model-value="modelValue"
    :label="label"
    :help-text="helpText"
    :hide-label="hideLabel"
    autocomplete-type="address"
    @update:model-value="handleModelValueUpdate"
    @place-selected="handlePlaceSelected"
  />
</template>

<script setup lang="ts">
import BaseLocationInput from './BaseLocationInput.vue';

type PlaceSuggestion = {
  place_id: string;
  description: string;
};

type Props = {
  modelValue?: string;
  label?: string;
  helpText?: string;
  hideLabel?: boolean;
};

const emit = defineEmits<{
  'update:modelValue': [value: string];
}>();

withDefaults(defineProps<Props>(), {
  modelValue: '',
  label: 'Location',
  helpText: undefined,
  hideLabel: false,
});

const handleModelValueUpdate = (value: string) => emit('update:modelValue', value);
const handlePlaceSelected = (item: PlaceSuggestion) => emit('update:modelValue', item.description);
</script>
